import { useInfiniteQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMemberInvitationsKey } from '../../utils/keys';
export const useMemberInvitations = (options) => {
    const { variables, fields = 'default', useInfiniteQueryOptions, } = options || {};
    const { client } = useTribeClient();
    const memberInvitationsKey = getMemberInvitationsKey({ variables, fields });
    return useInfiniteQuery(memberInvitationsKey, ({ pageParam: after }) => client === null || client === void 0 ? void 0 : client.invitations.list({ after, ...variables }, fields), useInfiniteQueryOptions);
};
//# sourceMappingURL=useMemberInvitations.js.map